import { axiosGet } from '@/api/handlers';
import { useQuery } from '@/api/hooks';
import { z } from 'zod';

const FiscalYearsModel = z.number().int().array();

export const useFiscalYearOptions = () => {
  return useQuery({
    queryKey: ['budgetTypes_fiscalYears'],
    queryFn: async () => {
      const res = await axiosGet('/api/budget-types/fiscal-years/');
      const data = FiscalYearsModel.parse(res);
      return data.map((d) => ({
        value: d.toString(),
        label: d.toString(),
      }));
    },
    gcTime: 60 * 60 * 12 * 1000,
    staleTime: 60 * 60 * 12 * 1000,
  });
};
